module.exports = __webpack_public_path__ + "img/impactbyte.89f4aa6a.png";